"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _authInformation = require("@/api/authInformation");
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2021 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default = exports.default = {
  name: 'i-copyright',
  data: function data() {
    return {
      links: [{
        title: '官网',
        key: '1',
        href: 'http://web.qmdzsw.cn/',
        blankTarget: true
      }, {
        title: '社区',
        key: '2',
        href: 'http://web.qmdzsw.cn/contactus/',
        blankTarget: true
      }, {
        title: '文档',
        key: '3',
        href: 'https://console-docs.apipost.cn/preview/d99116969d5c509f/b8d3278cdcfd3756',
        blankTarget: true
      }],
      copyright: 'Copyright © 2023 青岛青民数科科技有限公司',
      copyrightNew: ''
    };
  },
  mounted: function mounted() {
    this.getVersion();
  },
  methods: {
    getVersion: function getVersion() {
      var _this = this;
      (0, _authInformation.copyrightInfoApi)().then(function (res) {
        var data = res || {};
        _this.copyrightNew = data ? _this.copyright : _this.copyright;
      });
    }
  }
};